module.exports = __webpack_public_path__ + "2f72b555d07cff969103bf90e7686451.png";